module.exports = __webpack_public_path__ + "static/media/menuNegative.38225b60.png";